import React, { useState,useRef,useEffect } from 'react'
import {Link} from 'react-router-dom'
import trip_home_icon from '../../../assets/image/web-icons/home.png'
import { userActions } from '../../../functions/_actions'
import { useDispatch, useSelector } from 'react-redux'
import './../../../css/main.css'
import { history, config } from './../../../functions/_helpers'
import moment from 'moment'
import axios from 'axios';
import { isEmptyObject } from 'jquery'
import {authHeader} from './../../../functions/_helpers/auth-header'
import Widget from '../../forms/widget'
const ProfileEdit= ({items}) =>{
    const [shown, setShown] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const registering = useSelector(state => state.registration.registering);
    const dispatch = useDispatch();
    const [checkedItems, setCheckedItems] = useState({});
    const [changes, setChanges] = useState(false);
    const [file, setFile] = useState({});
    const [enabled, setEnabled] = useState(false);
    const [uploadProgress, updateUploadProgress] = useState(0);
    const [imageURI, setImageURI] = useState(null);
    const [uploadStatus, setUploadStatus] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [fileExists, isFileExists] = useState(false);
    const [showImage, setShowImage] = useState(false);     
    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    } 
    const [user, setUser] = useState({        
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        userPassword: '',
        contactMethod: 0,
        role: 0,
        company: '',
        isAdmin: false,    /*It will be used if the user is løyvehavere or sjåfører*/
        profileImageUrl: '',
        address: '',
        active:true,
        deleted:false,
        token:''
    });
    const [userContact, setUserContact] = useState({
        contactMethod : ''
    })
    let currentItem = JSON.parse(localStorage.getItem('user'))==null ?  [] : JSON.parse(localStorage.getItem('user'));
    //var currentItem = JSON.parse(localStorage.getItem('user'));
    var _firstName = ''
    var _lastName = ''
    var _phoneNumber = ''
    var _contactMethod=''
    var _address=''
    var _company= ''
    var profileImageUrl= ''
    var email=''
    var userId=''
    var userPassword=''
    var role=''
    var _token=''
   
    if(typeof(currentItem) !=='undefined'){
       
         
        [currentItem].map(item => (
           <li key={item.id} style={{display:"none"}}>
                {_firstName = item.firstName}
                {_lastName = item.lastName}
                {_phoneNumber = item.phoneNumber}
                {_contactMethod=item.contactMethod}
                {_address=item.address}
                {_company=item.company}
                {profileImageUrl= item.profileImageUrl}
                {email=item.email}
                {userId=item.id}
                {userPassword=item.userPassword}
                {role=item.role}
                {_token=item.token}
                
           </li>
           ))
           
   }else{
      
       history.goBack();
        
   }
    useEffect(() => {
        setUser(user => ({ ...user, firstName: _firstName, lastName:_lastName,phoneNumber:_phoneNumber,contactMethod:_contactMethod,address:_address,company:_company,profileImageUrl:profileImageUrl,
        email:email, userId:userId,role:role, userPassword:userPassword, token: _token}));
        setUserContact(userContact => ({...userContact, contactMethod: _contactMethod}));
        if(user.contactMethod === 1){
            setCheckedItems('email')
        }else if(user.contactMethod === 2){
            setCheckedItems('sms');
        }else if(user.contactMethod === 3){
            setCheckedItems('sms','email')
        }else{
            setCheckedItems('');
        }
        
    }, []);
    const checkboxes = [
        {
            name: 'email',
            key: 'email',
            label: 'Send epost',
        },
        {
            name: 'sms',
            key: 'sms',
            label: 'Send sms'
        }
    ];

    const handleChangeCheckbox = (event) => {
        // updating an object instead of a Map
        setChanges(true);
        setCheckedItems({...checkedItems, [event.target.name] : event.target.checked });
        console.log("checkedItems: ", checkedItems);
        if(checkedItems["email"]){
            user.contactMethod = 1;
        }else if(checkedItems["sms"]){
            user.contactMethod = 2;
        }else{
            user.contactMethod = 3;
        }
        
    }
    const checkFIle = async url => {
        return fetch(url, { method: "HEAD" });
      };
    function handleChange(e) {
        const { name, value } = e.target;
        setUser(user => ({ ...user, [name]: value }));
        setChanges(true);
    }
    function handleProfile(e){
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
            setChanges(true);
            setUploading(true);
            var file = e.target.files[0];
            var uuid = require("uuid");
            var id = uuid.v4();
            var names = [];
            var filename = file.name;
            names = filename.split('.');
            var newFileName = '';
            if(typeof names !== 'undefined'){
                newFileName = names[0] + "_" + id + '.'+names[1];
            }else{
                newFileName = file.name + "_" + id;
            }
            var formData = new FormData();
            formData.append('file', file, newFileName);
           
            axios({
                method: 'post',
                headers: {
                    ...authHeader(),
                    'Content-Type': 'multipart/form-data',
                },
                data: formData,
                url: process.env.REACT_APP_API_URL+'/api/upload',
                onUploadProgress: (ev) => {
                    const progress = ev.loaded / ev.total * 100;
                    updateUploadProgress(Math.round(progress));
                },
            })
            .then((resp) => {
                // our mocked response will always return true
                // in practice, you would want to use the actual response object
                setUploadStatus(true);
                setUploading(false);
                getBase64(file, (uri) => {
                    setImageURI(uri);
                    
                });
                setShowImage(true);
                user.profileImageUrl=process.env.REACT_APP_API_URL + '/wwwroot/Upload/Images/' + newFileName;  
                setUser(user => ({ ...user, profileImageUrl: process.env.REACT_APP_API_URL + '/wwwroot/Upload/Images/' + newFileName }));
            })
            .catch((err) => console.error(err));
   
    }

    function handleSubmit(e) {
        e.preventDefault();
        setSubmitted(true);
        setUser(user => ({ ...user, modifiedDate: moment.utc(new Date()).format().toLocaleString(), role: parseInt(user.role)}));
        if(changes){
            user.role = parseInt(user.role)
            if(user.role === 1){
                user.isAdmin=true;
            }
            localStorage.setItem('user',JSON.stringify(user));
            dispatch(userActions.updateUser(user));
            var start = new Date().getTime();
                var end = start;
                while(end < start + 1000) {
                    end = new Date().getTime();
                }
        }
        
        history.goBack();
    }
    
   const gotoHome = () => {
       history.push('/')
   }
   const renderSwitch = (param) => {
    switch(param) {
        case 1:
          return 'epost';
        case 2:
          return 'sms';
        case 3:
          return 'epost eller sms';
        default:
          return '';
      }
}
const handleBack = () => {
    history.goBack();
}
function dropHandler(ev) {
        
    ev.preventDefault();
    
    if (ev.dataTransfer.items) {
        setChanges(true);
      // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === 'file') {
          var file = ev.dataTransfer.items[i].getAsFile();

        setUploading(true);
        var uuid = require("uuid");
        var id = uuid.v4();
        var names = [];
        var filename = file.name;
        names = filename.split('.');
        var newFileName = '';
        if(typeof names !== 'undefined'){
            newFileName = names[0] + "_" + id + '.'+names[1];
        }else{
            newFileName = file.name + "_" + id;
        }
        var formData = new FormData();
        formData.append('file', file, newFileName);
        axios({
            method: 'post',
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data',
            },
            data: formData,
            url: process.env.REACT_APP_API_URL+'/api/upload',
            onUploadProgress: (ev) => {
                const progress = ev.loaded / ev.total * 100;
                updateUploadProgress(Math.round(progress));
            },
        })
        .then((resp) => {
           
            /*setUploadStatus(true);
            setUploading(false);
            getBase64(file, (uri) => {
                setImageURI(uri);
                
            });*/
            setShowImage(true);
            var uploadUrl = null;
            if(file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png"){
                uploadUrl = process.env.REACT_APP_API_URL + '/wwwroot/Upload/Images/';
            }else{
                uploadUrl = process.env.REACT_APP_API_URL + '/wwwroot/Upload/Doc/';
            }
            user.profileImageUrl=uploadUrl+newFileName;  
            setUser(user => ({ ...user, profileImageUrl: uploadUrl+newFileName }));
        })
        .catch((err) => console.error(err));

      }
     }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (i = 0; i < ev.dataTransfer.files.length; i++) {
        console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
      }
    }
   
  }
  function dragOverHandler(ev) {
    console.log('File(s) in drop zone'); 
  
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();
  }
    return (
        <>
        <Widget>
            {/*<div className="w-full lg:space-x-2 space-y-2 lg:space-y-0 mb-2 lg:mb-4 top-adjustment custom-border-main">*/}
                    
                        <div className="w-full trip_box ml-2 custom-add-item-border" style={{backgroundColor: "#ece9cb", overflowY:"scroll",height:"80vh",width:"98.8%"}}>
                            <form name="form" className="form profile_form" onSubmit={handleSubmit}>
                            <div className="flex flex-row items-center justify-start p-4">
                                <div className="flex-shrink-0 w-24">
                                    <img
                                    src={user.profileImageUrl}
                                    alt="media"
                                    className="shadow rounded-full h-20 w-20 shadow-outline mb-2"
                                    />
                                </div>
                                <div className="py-2 px-2">
                                    <p className="text-base font-bold whitespace-no-wrap"> {user.firstName + " " +user.lastName}  </p>
                                    <p className="text-sm text-grey-500 whitespace-no-wrap"> {(function() {
                                        switch (role) {
                                        case 1:
                                            return <span className="inline_btn" style={{backgroundColor:"#fff",textAlign:"center", paddingTop:"5px", marginTop:"3px"}}>Admin</span>;
                                        case 2:
                                            return <span style={{backgroundColor:"#fff",textAlign:"center", paddingTop:"5px", marginTop:"3px"}}>LøyveHaver</span>;
                                        case 3:
                                            return <span style={{backgroundColor:"#fff",textAlign:"center", paddingTop:"5px", marginTop:"3px"}}>Sjåfør</span>;
                                        default:
                                            return <span style={{backgroundColor:"#fff",textAlign:"center", paddingTop:"5px", marginTop:"3px"}}></span>
                                        }
                                    })()} </p>
                                    <div className="flex flex-row items-center justify-start w-full py-1 space-x-2">
                                    </div>
                                </div>
                                </div>
                                <div className="flex w-full drivers">
                                    <div className="col-8 col-md-6 col-lg-4 col-sm-4 col-xs-12 form-element">
                                        <label className="font-bold block"> Fornavn </label>
                                        <input type="text" style={{border:"1px solid #37708e"}} name="firstName" value={user.firstName} onChange={handleChange} className={'form-control' + (submitted && user.firstName ? ' is-invalid' : '')} />
                                        <label className="font-bold block"> Etternavn </label>
                                        <input type="text" style={{border:"1px solid #37708e"}} name="lastName"  value={user.lastName} onChange={handleChange} className={'form-control' + (submitted && user.lastName ? ' is-invalid' : '')} />
                                        <label className="font-bold block"> Adresse </label>
                                        <input type="text" style={{border:"1px solid #37708e"}} name="address" value={user.address} onChange={handleChange} className={'form-control' + (submitted && user.address ? ' is-invalid' : '')} />
                                        <label className="font-bold block"> Epost </label>
                                        <input type="text" style={{border:"1px solid #37708e"}} name="email" value={user.email} onChange={handleChange} className={'form-control' + (submitted && user.email ? ' is-invalid' : '')} />
                                    </div>
                                    <div className="col-8 col-md-6 col-lg-4 col-sm-4 col-xs-12 form-element">
                                        <label className="font-bold block"> Selskap </label>
                                        <input type="text" style={{border:"1px solid #37708e"}} name="company"  value={user.company} onChange={handleChange} className={'form-control' + (submitted && !user.company ? ' is-invalid' : '')} />

                                        <label className="font-bold block"> Telefonnummer </label>
                                        <input type="tel" style={{border:"1px solid #37708e"}} name="phoneNumber"  value={user.phoneNumber} onChange={handleChange} className={'form-control' + (submitted && !user.phoneNumber ? ' is-invalid' : '')} />

                                    </div>
                                    <div className="col-8 col-md-6 col-lg-4 col-sm-4 col-xs-12 profile_widget form-element">
                                        <label className="font-bold block"> Passord </label>
                                        <div className="flex">
                                            <input type="password" style={{border:"1px solid #37708e"}} name="userPassword" value={user.userPassword} onChange={handleChange} className={'form-control' + (submitted && !user.userPassword ? ' is-invalid' : '')} />
                                        </div>
                                        <label className="font-bold block"> Profilbilde(Passfoto) </label>
                                        <div className="flex profile_flex" style={{maxWidth:"279px",maxHeight:"279px",borderRadius:"10px",border:"1px solid #37708e"}}>
                                            <div className="widget">
                                                <div className="upload_file">
                                                    <div>
                                                        {showImage?
                                                        <>
                                                            <img src={user.profileImageUrl} alt="profileimg" style={{minWidth:"100%",height: "195px",objectFit:"cover"}} />
                                                        </>
                                                        :
                                                        <div id="drop_zone" onDrop={(e)=>dropHandler(e)} onDragOver={(e)=>dragOverHandler(e)}>
                                                            <label htmlFor="file-profile" type="file" onChange={handleProfile} className="custom-file-upload"> Dra & Slipp </label>
                                                                <p> eller klikk her for å laste opp fil </p>
                                                            <input id="file-profile" type="file" name="profileImageUrl" onChange={handleProfile} />
                                                        </div>
                                                        }
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*<div className="flex profile_flex">
                                            <div className="widget">
                                                <div className="upload_file h-32 p-8">
                                                    <div>
                                                    <img src={user.profileImageUrl} alt="profileimg" style={{height:"100px",minWidth:"100px"}}/>
                                                        <label htmlFor="file-profile" className="custom-file-upload"> Dra & Slipp </label>
                                                        <p> eller klikk her for å laste opp fil </p>
                                                        <input id="file-profile" type="file" name="profileImageUrl" onChange={handleProfile} />
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="inline_btns">
                                                <button type="button" className="inline_btn">  Nullstill</button>
                                                <button type="button" className="inline_btn"> VELG FIL</button>
                                            </div>
                                        </div>*/}
                                        <label className="font-bold block"> Rolle </label>
                                        <select className={'form-control' + (submitted && user.role ? ' is-invalid' : '')} name="role" value={user.role} onChange={handleChange}>
                                            <option value="" placeholder="Velge Rolle"></option>
                                            <option value="1"> Admin </option>
                                            <option value="2"> Løyvehaver </option>
                                            <option value="3"> Sjåfør </option>
                                        </select>
                                    </div>
                                </div>
                                <div className="send-information-form" style={{width: "300px",left: "10px",marginLeft: "25px", marginTop:"-72px",marginBottom:"50px"}}>
                                    
                                </div>
                                <div className="driver_btns text-right mt-10" style={{height:"45px",margin:"-5px auto"}}>
                                    <button className="sign_btn" style={{marginLeft:"10px",marginRight:"10px"}} onClick={()=>handleBack}> Tilbake </button>
                                    <button className="sign_btn"> Lagre {registering && <span className="spinner-border spinner-border-sm mr-1"></span>} </button>
                                </div>
                                
                            </form>
                        </div>

            {/*</div>*/}
        </Widget>
        </>
    )
}
export default ProfileEdit
